/**
 * Die Auswahl des Konditionswechsel-Grundes (`contract-terms-reason`,
 * Spec 04a, „Sheet Konditionen ändern"). Die Optionen kommen von
 * `GET /contracts/term-reasons` — derselbe Grund wie bei `UsageTypeField`:
 * der Client pflegt keine eigene Zuordnung von Werten auf deutsche
 * Bezeichnungen (`ARCHITECTURE.md` 5).
 *
 * Als einziges dieser Felder ohne sinnvolle Vorauswahl: Der Grund ist eine
 * bewusste Angabe, deshalb der gesperrte Platzhalter.
 */

import { useTermReasons } from '@/features/contracts/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface TermReasonFieldProps {
  readonly testId: string
  readonly errorPrefix: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
}

export function TermReasonField({
  testId,
  errorPrefix,
  value,
  onChange,
  error,
}: TermReasonFieldProps) {
  const reasonsQuery = useTermReasons()

  return (
    <EnumSelectField
      label="Grund"
      testId={testId}
      apiField="reason"
      errorPrefix={errorPrefix}
      options={reasonsQuery.data ?? []}
      isPending={reasonsQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      required
      placeholder="Bitte wählen"
    />
  )
}
